import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import './AdminPanel.css';

const AdminDashboard: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  return (
    <div className="admin-panel">
      <Header
        isMenuOpen={isMenuOpen}
        onMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />

      <div className="admin-content">
        <Sidebar isOpen={isMenuOpen} onToggle={() => !isMenuOpen ? setIsMenuOpen(true) : ""} />

        <main className="main-content">
          {/* 🔥 URL-based rendering happens here */}
          <Outlet />
        </main>
      </div>

      {/* <Footer /> */}
      {/* <Footer /> */}
    </div>
  );
};

export default AdminDashboard;
